import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import e from "../core/Plugin";

var t = /*#__PURE__*/function (_e) {
  _inherits(t, _e);

  var _super = _createSuper(t);

  function t(e) {
    var _this;

    _classCallCheck(this, t);

    _this = _super.call(this, e);
    _this.handlers = [];
    _this.timers = new Map();

    var _t = document.createElement("div");

    _this.defaultEvent = !("oninput" in _t) ? "keyup" : "input";
    _this.opts = Object.assign({}, {
      delay: 0,
      event: _this.defaultEvent,
      threshold: 0
    }, e);
    _this.fieldAddedHandler = _this.onFieldAdded.bind(_assertThisInitialized(_this));
    _this.fieldRemovedHandler = _this.onFieldRemoved.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(t, [{
    key: "install",
    value: function install() {
      this.core.on("core.field.added", this.fieldAddedHandler).on("core.field.removed", this.fieldRemovedHandler);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.handlers.forEach(function (e) {
        return e.element.removeEventListener(e.event, e.handler);
      });
      this.handlers = [];
      this.timers.forEach(function (e) {
        return window.clearTimeout(e);
      });
      this.timers.clear();
      this.core.off("core.field.added", this.fieldAddedHandler).off("core.field.removed", this.fieldRemovedHandler);
    }
  }, {
    key: "prepareHandler",
    value: function prepareHandler(e, _t2) {
      var _this2 = this;

      _t2.forEach(function (_t3) {
        var i = [];

        if (!!_this2.opts.event && _this2.opts.event[e] === false) {
          i = [];
        } else if (!!_this2.opts.event && !!_this2.opts.event[e]) {
          i = _this2.opts.event[e].split(" ");
        } else if ("string" === typeof _this2.opts.event && _this2.opts.event !== _this2.defaultEvent) {
          i = _this2.opts.event.split(" ");
        } else {
          var _e2 = _t3.getAttribute("type");

          var s = _t3.tagName.toLowerCase();

          var n = "radio" === _e2 || "checkbox" === _e2 || "file" === _e2 || "select" === s ? "change" : _this2.ieVersion >= 10 && _t3.getAttribute("placeholder") ? "keyup" : _this2.defaultEvent;
          i = [n];
        }

        i.forEach(function (i) {
          var s = function s(i) {
            return _this2.handleEvent(i, e, _t3);
          };

          _this2.handlers.push({
            element: _t3,
            event: i,
            field: e,
            handler: s
          });

          _t3.addEventListener(i, s);
        });
      });
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e, _t4, i) {
      var _this3 = this;

      if (this.exceedThreshold(_t4, i) && this.core.executeFilter("plugins-trigger-should-validate", true, [_t4, i])) {
        var s = function s() {
          return _this3.core.validateElement(_t4, i).then(function (s) {
            _this3.core.emit("plugins.trigger.executed", {
              element: i,
              event: e,
              field: _t4
            });
          });
        };

        var n = this.opts.delay[_t4] || this.opts.delay;

        if (n === 0) {
          s();
        } else {
          var _e3 = this.timers.get(i);

          if (_e3) {
            window.clearTimeout(_e3);
          }

          this.timers.set(i, window.setTimeout(s, n * 1e3));
        }
      }
    }
  }, {
    key: "onFieldAdded",
    value: function onFieldAdded(e) {
      this.handlers.filter(function (_t5) {
        return _t5.field === e.field;
      }).forEach(function (e) {
        return e.element.removeEventListener(e.event, e.handler);
      });
      this.prepareHandler(e.field, e.elements);
    }
  }, {
    key: "onFieldRemoved",
    value: function onFieldRemoved(e) {
      this.handlers.filter(function (_t6) {
        return _t6.field === e.field && e.elements.indexOf(_t6.element) >= 0;
      }).forEach(function (e) {
        return e.element.removeEventListener(e.event, e.handler);
      });
    }
  }, {
    key: "exceedThreshold",
    value: function exceedThreshold(e, _t7) {
      var i = this.opts.threshold[e] === 0 || this.opts.threshold === 0 ? false : this.opts.threshold[e] || this.opts.threshold;

      if (!i) {
        return true;
      }

      var s = _t7.getAttribute("type");

      if (["button", "checkbox", "file", "hidden", "image", "radio", "reset", "submit"].indexOf(s) !== -1) {
        return true;
      }

      var n = this.core.getElementValue(e, _t7);
      return n.length >= i;
    }
  }]);

  return t;
}(e);

export { t as default };